export class CurrentCredentials{
    public static username:string="Anonymous";
    public static password:string="Anonymous";
    public static personnelFullName:string="";
    public static personnelCode:string="";
    public static personnelId:string="";
}